import gql from 'graphql-tag'

export const newEventProject = gql`
  mutation newEventProject(
    $startedAt: DateTime
    $completedAt: DateTime
    $minutes: Int
    $dataOrigin: String!
    $eventType: String!
    $mood: Int
    $comment: String
    $trackerId: ID!
    $taskId: ID!
    $subtaskId: ID!
    $userId: ID!
  ) {
    createEvent(
      startedAt: $startedAt
      completedAt: $completedAt
      minutes: $minutes
      dataOrigin: $dataOrigin
      eventType: $eventType
      mood: $mood
      comment: $comment
      trackerId: $trackerId
      taskId: $taskId
      subtaskId: $subtaskId
      userId: $userId
    ) {
      id
    }
  }
`

export const updateEventProject = gql`
  mutation updateEventProject(
    $startedAt: DateTime
    $completedAt: DateTime
    $minutes: Int
    $eventType: String!
    $mood: Int
    $comment: String
    $trackerId: ID!
    $taskId: ID!
    $subtaskId: ID!
    $userId: ID!
    $id: ID!
  ) {
    updateEvent(
      startedAt: $startedAt
      completedAt: $completedAt
      minutes: $minutes
      eventType: $eventType
      mood: $mood
      comment: $comment
      trackerId: $trackerId
      taskId: $taskId
      subtaskId: $subtaskId
      userId: $userId
      id: $id
    ) {
      id
    }
  }
`

export const newEventDuration = gql`
  mutation newEventDuration(
    $startedAt: DateTime
    $completedAt: DateTime
    $minutes: Int
    $dataOrigin: String!
    $eventType: String!
    $options: Json
    $mood: Int
    $comment: String
    $trackerId: ID!
    $userId: ID!
  ) {
    createEvent(
      startedAt: $startedAt
      completedAt: $completedAt
      minutes: $minutes
      dataOrigin: $dataOrigin
      eventType: $eventType
      options: $options
      mood: $mood
      comment: $comment
      trackerId: $trackerId
      userId: $userId
    ) {
      id
    }
  }
`

export const updateEventDuration = gql`
  mutation updateEventDuration(
    $startedAt: DateTime
    $completedAt: DateTime
    $minutes: Int
    $eventType: String!
    $options: Json
    $mood: Int
    $comment: String
    $trackerId: ID!
    $userId: ID!
    $id: ID!
  ) {
    updateEvent(
      startedAt: $startedAt
      completedAt: $completedAt
      minutes: $minutes
      eventType: $eventType
      options: $options
      mood: $mood
      comment: $comment
      trackerId: $trackerId
      userId: $userId
      id: $id
    ) {
      id
    }
  }
`

export const newReadingEvent = gql`
  mutation newReadingEvent(
    $startedAt: DateTime
    $completedAt: DateTime
    $minutes: Int
    $dataOrigin: String!
    $eventType: String!
    $bookId: ID!
    $bookPrefId: ID!
    $options: Json
    $mood: Int
    $comment: String
    $trackerId: ID!
    $userId: ID!
  ) {
    createEvent(
      startedAt: $startedAt
      completedAt: $completedAt
      minutes: $minutes
      dataOrigin: $dataOrigin
      eventType: $eventType
      bookId: $bookId
      bookPrefId: $bookPrefId
      options: $options
      mood: $mood
      comment: $comment
      trackerId: $trackerId
      userId: $userId
    ) {
      id
    }
  }
`

export const updateReadingEvent = gql`
  mutation updateReadingEvent(
    $startedAt: DateTime
    $completedAt: DateTime
    $minutes: Int
    $eventType: String!
    $bookId: ID!
    $bookPrefId: ID!
    $options: Json
    $mood: Int
    $comment: String
    $trackerId: ID!
    $userId: ID!
    $id: ID!
  ) {
    updateEvent(
      startedAt: $startedAt
      completedAt: $completedAt
      minutes: $minutes
      eventType: $eventType
      bookId: $bookId
      bookPrefId: $bookPrefId
      options: $options
      mood: $mood
      comment: $comment
      trackerId: $trackerId
      userId: $userId
      id: $id
    ) {
      id
    }
  }
`

export const newEventValue = gql`
  mutation newEventValue(
    $startedAt: DateTime
    $completedAt: DateTime
    $dataOrigin: String!
    $eventType: String!
    $options: Json
    $mood: Int
    $comment: String
    $trackerId: ID!
    $userId: ID!
  ) {
    createEvent(
      startedAt: $startedAt
      completedAt: $completedAt
      dataOrigin: $dataOrigin
      eventType: $eventType
      options: $options
      mood: $mood
      comment: $comment
      trackerId: $trackerId
      userId: $userId
    ) {
      id
    }
  }
`

export const updateEventValue = gql`
  mutation updateEventValue(
    $startedAt: DateTime
    $completedAt: DateTime
    $eventType: String!
    $options: Json
    $mood: Int
    $comment: String
    $trackerId: ID!
    $userId: ID!
    $id: ID!
  ) {
    updateEvent(
      startedAt: $startedAt
      completedAt: $completedAt
      eventType: $eventType
      options: $options
      mood: $mood
      comment: $comment
      trackerId: $trackerId
      userId: $userId
      id: $id
    ) {
      id
    }
  }
`

export const deleteEvent = gql`
  mutation deleteEvent($id: ID!) {
    deleteEvent(id: $id) {
      id
    }
  }
`

export const addToEvent = gql`
  mutation addToEvent($events1EventId: ID!, $events2EventId: ID!) {
    addToEventsOnEvent(
      events1EventId: $events1EventId
      events2EventId: $events2EventId
    ) {
      events1Event {
        id
      }
    }
  }
`
export const updateEventType = gql`
  mutation updateEventType($id: ID!, $userId: ID!, $eventType: String!) {
    updateEvent(id: $id, userId: $userId, eventType: $eventType) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/event.js